<template>
  <ul :data-testid="testId([navGroupItem.key])" class="mb-8">
    <li
      v-if="!hideGroupLabel"
      :data-testid="testId([navGroupItem.key, 'header'])"
      class="mb-3 font-bold uppercase"
    >
      {{ translateLabel(navGroupItem) }}
    </li>

    <navigation-sidebar-link-anchor
      v-for="navItem in navGroupItem.items"
      :key="
        navItem.data.url != null
          ? `${navItem.data.url}__${navItem.key}`
          : `${navItem.label}__${navItem.key}`
      "
      :nav-item="navItem"
    />
  </ul>
</template>

<script setup lang="ts">
import testId from '~/helpers/testid';
import type { SideNavigationGroupItem } from '#variant/components/navigation/types';
import { useLabelTranslation } from '../features/utils';

defineProps<{
  navGroupItem: SideNavigationGroupItem;
  hideGroupLabel?: boolean;
}>();

const translateLabel = useLabelTranslation();
</script>
